export default __webpack_public_path__ + "static/media/grey_option.78c6bbc8.svg";